/* eslint-disable unicorn/no-null */
/* eslint-disable unicorn/consistent-function-scoping */
import {
  profileAboutYouUpdate,
  profileJuridictionUpdate,
  profileLanguageUpdate,
  profilePracticeAreaUpdate,
  profileTargetLocationsUpdate,
} from '../../../segment'
import {wrap} from '../../loading-overlay'
import {isAnyObjectSelected} from './../../utils/common'

const lawyerPreferencesController = (
  $scope,
  $rootScope,
  $modal,
  api,
  logger,
  locationsService,
  CandidatePreferencesApi,
  CandidateProfileApi
) => {
  const updateLocations = async function(request) {
    const temporarySelectedLocations = locationsService.linearize(
      request.updated_data
    )

    let trackLocations = []
    temporarySelectedLocations.forEach(loc => {
      trackLocations.push(loc.loc_name)
    })

    trackLocations = trackLocations.join()

    profileTargetLocationsUpdate(trackLocations)

    const updateLocationsModel = () => {
      $scope.linearLocations = temporarySelectedLocations
      $scope.nestedLocations = request.updated_data

      logger.notify(
        'success',
        `Your target Locations have been successfully updated`
      )
    }

    if (isAnyObjectSelected(temporarySelectedLocations)) {
      await wrap(async () =>
        api
          .updateLocationsForLawyer(request)
          .then(updateLocationsModel)
          .catch($rootScope.errorHandler)
      )
    } else {
      logger.notify(
        'error',
        'This is a required field, you have to choose at least one location.'
      )
    }
  }

  const updatePractices = async function(request) {
    const updatePracticesModel = () => {
      $scope.linearPractices = request.linearPractices
      $scope.nestedPractices = request.updated_data

      let trackPracticeAreas = []
      $scope.linearPractices.forEach(pa => {
        if (pa.isSelected) {
          trackPracticeAreas.push(pa.practice_name)
        }
      })

      trackPracticeAreas = trackPracticeAreas.join()

      profilePracticeAreaUpdate(trackPracticeAreas)

      logger.notify(
        'success',
        `Your target Practice Areas have been successfully updated`
      )
    }

    if (isAnyObjectSelected(request.linearPractices)) {
      await wrap(async () =>
        api
          .updatePracticesForLawyer(request)
          .then(updatePracticesModel)
          .catch($rootScope.errorHandler)
      )
    } else {
      logger.notify(
        'error',
        'This is a required field, you have to choose at least one practice area.'
      )
    }
  }

  const updateJurisdictions = async function(request) {
    const updateJurisdictionsModel = async () => {
      $scope.jurisdictions = angular.copy(request.updated_data)
      $scope.onJurisdictionUpdate({selectedJurisdiction: $scope.jurisdictions})

      let trackJurisdictions = []

      $scope.jurisdictions.forEach(juris => {
        if (juris.isSelected) {
          trackJurisdictions.push(juris.name)
        }
      })

      trackJurisdictions = trackJurisdictions.join()

      profileJuridictionUpdate(trackJurisdictions)
      $scope.$apply()

      if (!$scope.loggerInActive)
        logger.notify(
          'success',
          `Your target Jurisdictions have been successfully updated`
        )
    }

    const jurisdictions = request.updated_data
      .filter(jurisdiction => jurisdiction.isSelected)
      .map(jurisdiction => jurisdiction.id)

    if (isAnyObjectSelected(request.updated_data)) {
      await wrap(async () =>
        CandidatePreferencesApi.updateCandidatePreferences(
          $scope.candidate.id,
          {
            specialtiesByCategory: [{id: 3, specialties: jurisdictions}],
          }
        )
          .then(updateJurisdictionsModel)
          .catch($rootScope.errorHandler)
      )
    } else {
      logger.notify('warning', `Please select at least one Jurisdiction.`)
    }
  }

  const updateLanguages = async request => {
    const updateLanguagesModel = () => {
      $scope.languages = angular.copy(request.updated_data)

      let trackLanguages = []
      $scope.languages.forEach(lang => {
        if (lang.isSelected) {
          trackLanguages.push(lang.language_name)
        }
      })

      trackLanguages = trackLanguages.join()

      profileLanguageUpdate(trackLanguages)
      $scope.$apply()
      logger.notify(
        'success',
        `Successfully updated the lawyer's selected languages`
      )
    }

    const languages = request.updated_data
      .filter(language => language.isSelected)
      .map(language => language.code)

    await wrap(async () =>
      CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
        languages,
      })
    )
      .then(updateLanguagesModel)
      .catch($rootScope.errorHandler)
  }

  const updateMove = async function() {
    const updateMoveModel = () => {
      if ($scope.candidate.infoMotivation === '') {
        $scope.candidate.infoMotivation = null
      } else {
        profileAboutYouUpdate({
          question: 'Why are you looking to make a move?',
          answer: $scope.candidate.infoMotivation,
        })
      }

      logger.notify('success', 'Successfully updated')
    }

    await wrap(async () =>
      CandidateProfileApi.updateProfileData($scope.candidate.id, {
        infoMotivation: $scope.candidate.infoMotivation,
      })

        .then(updateMoveModel)
        .catch($rootScope.errorHandler)
    )
  }

  const updateInfo = async function() {
    const updateMoveModel = () => {
      if ($scope.candidate.infoAdditional === '') {
        $scope.candidate.infoAdditional = null
      } else {
        profileAboutYouUpdate({
          question:
            'Is there any additional information that you would like to add?',
          answer: $scope.candidate.infoAdditional,
        })
      }

      logger.notify('success', 'Successfully updated')
    }

    await wrap(async () =>
      CandidateProfileApi.updateProfileData($scope.candidate.id, {
        infoAdditional: $scope.candidate.infoAdditional,
      })
        .then(updateMoveModel)
        .catch($rootScope.errorHandler)
    )
  }

  const getLocationsModalData = () => {
    return {
      element: 'location',
      data: angular.copy($scope.nestedLocations),
    }
  }

  const getPracticesModalData = () => {
    return {
      element: 'practice',
      data: angular.copy($scope.nestedPractices),
      linearPractices: angular.copy($scope.linearPractices),
    }
  }

  const getMoveModalData = () => {
    return {
      element: 'move',
      data: angular.copy($scope.candidate.infoMotivation),
    }
  }

  const getInfoModalData = () => {
    return {
      element: 'info',
      data: angular.copy($scope.candidate.infoAdditional),
    }
  }

  const getJurisdictionsModalData = () => {
    return {
      element: 'jurisdiction',
      data: angular.copy($scope.jurisdictions),
    }
  }

  const getLanguagesModalData = () => {
    return {
      element: 'language',
      data: angular.copy($scope.languages),
    }
  }

  const getDataObjectForTheModal = elementId => {
    let modalDataObject = {
      displayNextButton: $scope.displayNextButton,
    }

    switch (elementId) {
      case 'edit-locations':
        Object.assign(modalDataObject, getLocationsModalData())
        break
      case 'edit-practices':
        Object.assign(modalDataObject, getPracticesModalData())
        break
      case 'edit-move':
        Object.assign(modalDataObject, getMoveModalData())
        break
      case 'edit-info':
        Object.assign(modalDataObject, getInfoModalData())
        break
      case 'edit-jurisdictions':
        Object.assign(modalDataObject, getJurisdictionsModalData())
        break
      case 'edit-languages':
        Object.assign(modalDataObject, getLanguagesModalData())
        break
      default:
        modalDataObject = undefined
    }

    return modalDataObject
  }

  const updateRespectivePreference = selectedItem => {
    let updatedData = {
      currentLawyer: $scope.candidate.id,
      // eslint-disable-next-line camelcase
      updated_data: selectedItem.data,
    }
    switch (selectedItem.element) {
      case 'location':
        updateLocations(updatedData)
        break
      case 'practice':
        updatedData.linearPractices = selectedItem.linearPractices
        updatePractices(updatedData)
        break
      case 'move':
        $scope.candidate.infoMotivation = selectedItem.data
        updateMove(updatedData)
        break
      case 'info':
        $scope.candidate.infoAdditional = selectedItem.data
        updateInfo(updatedData)
        break
      case 'jurisdiction':
        updateJurisdictions(updatedData)
        break
      case 'language':
        updateLanguages(updatedData)
        break
      default:
    }
  }

  const modalOpenHandler = elementId => {
    let modalInstance

    modalInstance = $modal.open({
      backdrop: 'static',
      templateUrl: 'lawyer-preferences-template.html',
      controller: 'ProfileModalCtrl',
      resolve: {
        data: () => getDataObjectForTheModal(elementId),
      },
    })

    return modalInstance.result.then(updateRespectivePreference)
  }

  $scope.modalOpenHandler = modalOpenHandler
}

export {lawyerPreferencesController}



// WEBPACK FOOTER //
// ./scripts/shared/directives/lawyer-preferences/controller.js